export enum ResourceNames {
  DASHBOARD = 'DASHBOARD',

  AI_AGENT = 'AI_AGENT',
  AI_AGENT__MENU = 'AI_AGENT__MENU',
  AI_AGENT_CUSTOM = 'AI_AGENT_CUSTOM',
  AI_AGENT_CUSTOM__MENU = 'AI_AGENT_CUSTOM__MENU',
  AI_AGENT__RESPONSE_RATING = 'AI_AGENT__RESPONSE_RATING',
  AI_AGENT__SUGGESTIONS = 'AI_AGENT__SUGGESTIONS',
  AI_AGENT__SUGGESTIONS_APPROVE = 'AI_AGENT__SUGGESTIONS_APPROVE',
  AI_AGENT__INTERNAL_EXECUTIONS = 'AI_AGENT__INTERNAL_EXECUTIONS',

  ATTENDANCE = 'ATTENDANCE',
  ATTENDANCE__CALLS = 'ATTENDANCE__CALLS',
  ATTENDANCE__CHATLIST = 'ATTENDANCE__CHATLIST',
  ATTENDANCE__CHATS = 'ATTENDANCE__CHATS',
  ATTENDANCE__TIME_LINE = 'ATTENDANCE__TIME_LINE',
  ATTENDANCE__CONTACTS = 'ATTENDANCE__CONTACTS',
  ATTENDANCE__USERS = 'ATTENDANCE__USERS',
  ATTENDANCE__SEARCH_FEEDBACK = 'ATTENDANCE__SEARCH_FEEDBACK',
  ATTENDANCE__EMAIL = 'ATTENDANCE__EMAIL',
  ATTENDANCE__HUBSOFT = 'ATTENDANCE__HUBSOFT',
  ATTENDANCE__ACELERATO = 'ATTENDANCE__ACELERATO',
  ATTENDANCE__PIPEDRIVE = 'ATTENDANCE__PIPEDRIVE',
  ATTENDANCE__INSIDE_SISTEMAS = 'ATTENDANCE__INSIDE_SISTEMAS',
  ATTENDANCE__MODERNA = 'ATTENDANCE__MODERNA',
  ATTENDANCE__SNIPERSELL = 'ATTENDANCE__SNIPERSELL',

  ADMINISTRATION = 'ADMINISTRATION',
  ADMINISTRATION__API = 'ADMINISTRATION__API',
  ADMINISTRATION__DIALER = 'ADMINISTRATION__DIALER',
  ADMINISTRATION__CUSTOMERS = 'ADMINISTRATION__CUSTOMERS',
  ADMINISTRATION__USERS = 'ADMINISTRATION__USERS',
  ADMINISTRATION__PROFILES = 'ADMINISTRATION__PROFILES',
  ADMINISTRATION__MY_PROFILE = 'ADMINISTRATION__MY_PROFILE',
  ADMINISTRATION__ACCESS_CONTROL = 'ADMINISTRATION__ACCESS_CONTROL',
  ADMINISTRATION__PARAMETERS = 'ADMINISTRATION__PARAMETERS',
  ADMINISTRATION__GLOBAL_CONFIGURATIONS = 'ADMINISTRATION__GLOBAL_CONFIGURATIONS',
  ADMINISTRATION__LOGIN_AS = 'ADMINISTRATION__LOGIN_AS',
  ADMINISTRATION__MARKETPLACE = 'ADMINISTRATION__MARKETPLACE',
  ADMINISTRATION__SECURITY = 'ADMINISTRATION__SECURITY',
  ADMINISTRATION__IDENTITY_PROVIDERS = 'ADMINISTRATION__IDENTITY_PROVIDERS',
  ADMINISTRATION__MAIL_CAPACITY = 'ADMINISTRATION__MAIL_CAPACITY',
  ADMINISTRATION__MAINTENANCE_NOTIFICATION = 'ADMINISTRATION__MAINTENANCE_NOTIFICATION',
  ADMINISTRATION__REQUEST_LOGS = 'ADMINISTRATION__REQUEST_LOGS',

  KANBAN = 'KANBAN',
  KANBAN__CATEGORIES = 'KANBAN__CATEGORIES',

  METADATA = 'METADATA',
  METADATA__ADVANCED_REPORTS = 'METADATA__ADVANCED_REPORTS',
  METADATA__INDICATORS = 'METADATA__INDICATORS',

  MONITORING = 'MONITORING',
  MONITORING__AGENTS = 'MONITORING__AGENTS',
  MONITORING__TEAMS = 'MONITORING__TEAMS',
  MONITORING__CAMPAIGNS = 'MONITORING__CAMPAIGNS',
  MONITORING__DIALER = 'MONITORING__DIALER',
  MONITORING__AI_AGENT = 'MONITORING__AI_AGENT',
  MONITORING__AI_SESSIONS = 'MONITORING__AI_SESSIONS',
  ADMINISTRATION__AI_SESSIONS = 'ADMINISTRATION__AI_SESSIONS',
  MONITORING__BLOCK_AGENT = 'MONITORING__BLOCK_AGENT',

  KANBAN__SALES_FUNNEL = 'KANBAN__SALES_FUNNEL',

  BOT_MENU = 'BOT_MENU',
  BOT_MENU__FLOWS = 'BOT_MENU__FLOWS',

  MARKETPLACE = 'MARKETPLACE',

  INTEGRATIONS = 'INTEGRATIONS',

  SUPERVISION = 'SUPERVISION',
  SUPERVISION__CONTACTS = 'SUPERVISION__CONTACTS',
  SUPERVISION__HOLIDAYS = 'SUPERVISION__HOLIDAYS',
  SUPERVISION__TAGS = 'SUPERVISION__TAGS',
  SUPERVISION__VIRTUAL_AGENTS = 'SUPERVISION__VIRTUAL_AGENTS',
  SUPERVISION__HORARYS = 'SUPERVISION__HORARYS',
  SUPERVISION__TEAMS = 'SUPERVISION__TEAMS',
  SUPERVISION__TEMPLATE_HSM = 'SUPERVISION__TEMPLATE_HSM',
  SUPERVISION__TEMPLATE_RCS = 'SUPERVISION__TEMPLATE_RCS',
  SUPERVISION__WHATSAPP_FORMS = 'SUPERVISION__WHATSAPP_FORMS',
  SUPERVISION__PROTOCOLS = 'SUPERVISION__PROTOCOLS',
  SUPERVISION__TABULATIONS = 'SUPERVISION__TABULATIONS',
  SUPERVISION__CHANNELS = 'SUPERVISION__CHANNELS',
  SUPERVISION__CHANNELS_WHATSAPP = 'SUPERVISION__CHANNELS_WHATSAPP',
  SUPERVISION__CHANNELS_EMAIL = 'SUPERVISION__CHANNELS_EMAIL',
  SUPERVISION__CHANNELS_INSTAGRAM = 'SUPERVISION__CHANNELS_INSTAGRAM',
  SUPERVISION__CHANNELS_LINKEDIN = 'SUPERVISION__CHANNELS_LINKEDIN',
  SUPERVISION__CHANNELS_FACEBOOK = 'SUPERVISION__CHANNELS_FACEBOOK',
  SUPERVISION__CHANNELS_WIDGET = 'SUPERVISION__CHANNELS_WIDGET',
  SUPERVISION__CHANNELS_TELEGRAM = 'SUPERVISION__CHANNELS_TELEGRAM',
  SUPERVISION__CHANNELS_TELEGRAM_API = 'SUPERVISION__CHANNELS_TELEGRAM_API',
  SUPERVISION__CHANNELS_RCS = 'SUPERVISION__CHANNELS_RCS',
  SUPERVISION__CHANNELS_MS_TEAMS = 'SUPERVISION__CHANNELS_MS_TEAMS',
  SUPERVISION__MARKETING_CAMPAIGN = 'SUPERVISION__MARKETING_CAMPAIGN',
  SUPERVISION__CHANNELS_RECLAME_AQUI = 'SUPERVISION__CHANNELS_RECLAME_AQUI',
  SUPERVISION__DIALER_CAMPAIGN = 'SUPERVISION__DIALER_CAMPAIGN',
  SUPERVISION__CATALOG = 'SUPERVISION__CATALOG',
  SUPERVISION__RESOURCES_GALLERY = 'SUPERVISION__RESOURCES_GALLERY',
  SUPERVISION__PAUSES = 'SUPERVISION__PAUSES',
  SUPERVISION__COST_CENTER = 'SUPERVISION__COST_CENTER',
  SUPERVISION__FAST_MESSAGE = 'SUPERVISION__FAST_MESSAGE',
  SUPERVISION__GOOD_AND_BAD_WORDS = 'SUPERVISION__GOOD_AND_BAD_WORDS',
  SUPERVISION__SATISFACTION_SURVEYS = 'SUPERVISION__SATISFACTION_SURVEYS',
  SUPERVISION__WEBLINKS = 'SUPERVISION__WEBLINKS',
  SUPERVISION__TASK_CATEGORY = 'SUPERVISION__TASK_CATEGORY',
  SUPERVISION__BLACKLIST = 'SUPERVISION__BLACKLIST',
  SUPERVISION__QUALITY_MONITORING = 'SUPERVISION__QUALITY_MONITORING',
  SUPERVISION__KNOWLEDGE_BASE = 'SUPERVISION__KNOWLEDGE_BASE',

  REPORTS = 'REPORTS',
  RESOURCES = 'RESOURCES',
  REPORTS__TAGS = `REPORTS__TAGS`,
  REPORTS__CONDITIONALS = 'REPORTS__CONDITIONALS',
  REPORTS__LOGIN_LOGOUT = 'REPORTS__LOGIN_LOGOUT',
  REPORTS__TEMPLATE = 'REPORTS__TEMPLATE',
  REPORTS__DOWNLOAD_HISTORY = 'REPORTS__DOWNLOAD_HISTORY',

  REPORTS__CAMPAIGN = 'REPORTS__CAMPAIGN',
  REPORTS__PAUSE = 'REPORTS__PAUSE',
  REPORTS__AWAY = 'REPORTS__AWAY',
  REPORTS__BLOCK = 'REPORTS__BLOCK',
  REPORTS__TEAMS = 'REPORTS__TEAMS',
  REPORTS__ATTENDANCE = 'REPORTS__ATTENDANCE',
  REPORTS__SURVEY_SATISFACTION = 'REPORTS__SURVEY_SATISFACTION',
  REPORTS__WORKFLOW = 'REPORTS__WORKFLOW',
  REPORTS__USER_MESSAGING = 'REPORTS__USER_MESSAGING',
  REPORTS__TEMPLATE_LIMIT = 'REPORTS__TEMPLATE_LIMIT',
  REPORTS__ASSIGNMENT = 'REPORTS__ASSIGNMENT',
  REPORTS__AI_AGENT = 'REPORTS__AI_AGENT',

  REPORTS__TABULATION = 'REPORTS__TABULATION',
  REPORTS__SMS = 'REPORTS__SMS',
  REPORTS__CHAT = 'REPORTS__CHAT',
  TASKS = 'TASKS',

  REPORTS_TELEPHONY = 'REPORTS_TELEPHONY',
  REPORTS_TELEPHONY__CALLS = 'REPORTS_TELEPHONY__CALLS',
  REPORTS_TELEPHONY__RECORD = 'REPORTS_TELEPHONY__RECORD',
  REPORTS_TELEPHONY__DIALER = 'REPORTS_TELEPHONY__DIALER',
  REPORTS_TELEPHONY__URA = 'REPORTS_TELEPHONY__URA',
  REPORTS_TELEPHONY__CALLS_BY_TEAM = 'REPORTS_TELEPHONY__CALLS_BY_TEAM',
  REPORTS_TELEPHONY__CALLS_BY_USER = 'REPORTS_TELEPHONY__CALLS_BY_USER',

  RESOURCES__FUNNEL_FORM = 'RESOURCES__FUNNEL_FORM',

  WORKFLOW = 'WORKFLOW',

  QUALITY_MONITORING = 'QUALITY_MONITORING',
  QUALITY_MONITORING__TEMPLATES = 'QUALITY_MONITORING__TEMPLATES',

  CAMPAIGNS = 'CAMPAIGNS',
  CAMPAIGNS__CONTACT_LIST = 'CAMPAIGNS__CONTACT_LIST',
  CAMPAIGNS__CONTACT = 'CAMPAIGNS__CONTACT',
  CAMPAIGNS__EMAIL = 'CAMPAIGNS__EMAIL',
  CAMPAIGNS__EMAIL_HEALTH = 'CAMPAIGNS__EMAIL_HEALTH',
}

export enum PermissionType {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  LIST_ALL = 'list_all',
  LIST_HISTORY = 'list_history',
  TRANSFER = 'transfer',
  FINISH = 'finish',
  VERIFICATION = 'verification',
  PAUSE = 'pause',
  FORWARD = 'forward',
  CREATE_FIELD = 'create_field',
  UPDATE_FIELD = 'update_field',
  DELETE_FIELD = 'delete_field',
  REQUIRED_FIELDS = 'required_fields',
  FILTER_TEAMS = 'filter_teams',
  OTHER_CHATS_INTERACTION = 'other_chats_interaction',
  START_FROM_OTHER_TEAMS = 'start_from_other_teams',
  EXPORT = 'export',
  UPDATE_TAG = 'update_tag',
  CADASTRAL_CHANGE = 'cadastral_change',
  SEND_SMS = 'send_sms',
  SEND_PRODUCT = 'send_product',
  BY_WHATSAPP = 'by_whatsapp',

  /* for complete admin */
  FULL_ADMIN_ENABLED = 'FULL_ADMIN_ENABLED',

  /* attendance view */
  VIEW_DELAYED = 'VIEW_DELAYED',
  VIEW_ARCHIVED = 'VIEW_ARCHIVED',
  VIEW_FINISHED = 'VIEW_FINISHED',
  VIEW_FLOW = 'VIEW_FLOW',
  VIEW_API = 'VIEW_API',
  VIEW_WORKFLOW = 'VIEW_WORKFLOW',
}

export enum ProfileLevel {
  MIN = 0,
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}
